import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getNicheLandingByPath } from "../../constants/nicheLandingPages";
import {
    buildDynamicNicheLandingSeo,
} from "../../utils/pageMeta";
import PageHeader, { PageShell } from "../shared/PageHeader";
import GuestHomeBanner from "../dashboard/GuestHomeBanner";
import OpportunityPreview from "../dashboard/OpportunityPreview";
import { setActiveNiche } from "../../store/nicheSlice";
import { getNicheBannerImage } from "../../constants/nicheBannerImages";

export default function NicheLanding() {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const config = getNicheLandingByPath(pathname);
    const [loadedOpportunities, setLoadedOpportunities] = useState([]);

    useEffect(() => {
        if (config?.id) {
            dispatch(setActiveNiche(config.id));
        }
    }, [dispatch, config?.id]);

    const pageSeo = useMemo(
        () => (config ? buildDynamicNicheLandingSeo(config, loadedOpportunities) : null),
        [config, loadedOpportunities]
    );

    if (!config) {
        return <Navigate to="/404" replace />;
    }

    return (
        <PageShell className="md:mt-0 px-0 mx-0">
            <PageHeader
                title={config.header}
                visible={false}
                metaTitle={config.seoTitle}
                metaDescription={pageSeo.metaDescription}
                metaKeywords={pageSeo.metaKeywords}
                path={config.path}
                imagePath="/og-image.png"
                imageAlt={`${config.header} — EzePulse`}
                structuredData={pageSeo.structuredData}
            />

            <GuestHomeBanner
                title={config.header}
                description={config.description}
                wizardRef={config.path}
                backgroundImage={getNicheBannerImage(config.id)}
            />

            <OpportunityPreview
                onOpportunitiesLoaded={setLoadedOpportunities}
                wizardRef={config.path}
                niche={config.id}
            />
        </PageShell>
    );
}
